"use client";

import * as React from "react";
import CircleSmall from "../../icons/CircleSmall";
const ListItem = ({
  label,
  children,
  icon = /*#__PURE__*/React.createElement(CircleSmall, null),
  dataTest
}) => {
  return /*#__PURE__*/React.createElement("li", {
    "data-test": dataTest,
    className: "orbit-list-item font-base mb-100 flex last:m-0 last-of-type:m-0"
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: "orbit-list-item-icon me-200 [&>.orbit-carrier-logo]:size-icon-small [&>.orbit-carrier-logo>img]:size-icon-small flex flex-none"
  }, icon), /*#__PURE__*/React.createElement("span", {
    className: "w-full"
  }, label && /*#__PURE__*/React.createElement("div", {
    className: "orbit-list-item-label font-base text-secondary-foreground font-normal"
  }, label), children));
};
export default ListItem;